function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Fragment } from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import DeleteIcon from "@mui/icons-material/DeleteForever";
//Limitless imports
import OkCancelDialog from "../../dialogs/ok-cancel-dialog/OkCancelDialog";
import HeaderIconButton from "../../buttons/header-icon-button/HeaderIconButton";
export const DeleteRowActionCell = ({
  rowIndex,
  onDeleteConfirm,
  tooltip,
  itemName,
  title,
  description,
  icon,
  ...rest
}) => {
  const [showDialog, setShowDialog] = React.useState(false);
  const handleDelete = event => {
    event.stopPropagation();
    setShowDialog(false);
    onDeleteConfirm(rowIndex);
  };
  const handleCancelClick = event => {
    event.stopPropagation();
    setShowDialog(false);
  };
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(HeaderIconButton, _extends({
    buttonId: `${tooltip.toLowerCase()}${rowIndex}`,
    onButtonClick: () => setShowDialog(true),
    tooltip: tooltip,
    icon: icon || /*#__PURE__*/React.createElement(DeleteIcon, null)
  }, rest)), showDialog && /*#__PURE__*/React.createElement(OkCancelDialog, {
    title: title || `Delete ${itemName}`,
    okLabel: "Confirm",
    onOKClick: handleDelete,
    onCancelClick: handleCancelClick,
    dialogProps: {
      onBackdropClick: handleCancelClick
    },
    okId: "deleteRowButton"
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary"
  }, description || `Are you sure you want to delete this ${itemName}?`)));
};
export default DeleteRowActionCell;
DeleteRowActionCell.propTypes = {
  onDeleteConfirm: PropTypes.func.isRequired,
  rowIndex: PropTypes.number.isRequired,
  tooltip: PropTypes.string.isRequired,
  itemName: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.node
};
DeleteRowActionCell.defaultProps = {
  itemName: "row"
};